import React from 'react'
import './Overview.css'
import OverviewHeader from './component/OverviewHeader'
import OverviewList from './component/OverviewList'

const Overview = () => {
  return (
    <>
       <OverviewHeader/>
       <div className='p-4'>
            <div className='main-content-div'>
                    <OverviewList/>
            </div>
       </div>
    </>
  )
}

export default Overview
